// extracted by mini-css-extract-plugin
export default {"button":"ServiceItem_button__K0CCO"};